import {Card} from "@varymadellc/my-weed-club-component-library";
import cx from "classnames";

export interface ProfileCardProps {
    title?: string;
    height?: string | number;
    children: React.ReactNode;
    noPadding?: boolean;
    className?: string;
    [key: string]: any;
}

export default function ProfileCard({title, children, height, noPadding = false, className, ...rest}: ProfileCardProps) {
    return (
        <Card inline style={{height}}
              className={cx("relative bg-dark-black !border border-gray-700 !overflow-hidden max-h-full !p-0 h-full overflow-hidden w-full", className)}
              {...rest}>
            {
                title && <div className="absolute left-4 top-0 w-auto rounded-b z-[100] p-1 bg-secondary font-bold ">
                    <h3 className="text-sm text-white text-xl font-thin">{title}</h3>
                </div>
            }
            <div style={{height}}
                 className={cx("max-h-full w-full z-0 overflow-y-scroll h-full mt-2 scroll-y", {'pt-10 px-2 pb-2': !noPadding})}>
                {children}
            </div>
        </Card>
    );
}